















































































































import Vue from 'vue';
import GiftStatus from '@/web/components/gift/GiftStatus.vue';

export default Vue.extend({
  name: 'GiftPurchasesDetailsModal',
  components: {
    GiftStatus,
  },
  props: {
    giftPurchase: {
      type: Object,
      default: null,
    },
    currency: {
      type: String,
      default: null,
    },
  },
  methods: {
    edit() {
      this.$emit('close');
      this.$parent.$emit('edit');
    },
    resend() {
      this.$emit('close');
      this.$parent.$emit('resend');
    },
  },
});
